module.exports = __webpack_public_path__ + "img/fourday_ps_29.7c6d23a8.jpg";